module.exports = __webpack_public_path__ + "static/img/ic-plus-gray.cece62c3.svg";